import { render } from "./FaqsDetail.vue?vue&type=template&id=611d865b"
import script from "./FaqsDetail.vue?vue&type=script&lang=js"
export * from "./FaqsDetail.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import FaqEditItem from "@/components/FaqEditItem.vue";
script.components = Object.assign({}, { Breadcrumbs, FaqEditItem }, script.components);